import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export function AvatarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="currentColor" opacity="0.1" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 14.9C18.433 14.9 20 13.3554 20 11.45C20 9.54465 18.433 8 16.5 8C14.567 8 13 9.54465 13 11.45C13 13.3554 14.567 14.9 16.5 14.9ZM23 20.8032C23 22.6956 20.09 23.9968 16.5002 23.9968H16.4998C12.91 23.9968 10 22.6956 10 20.8032C10 19.0762 11.6774 17.1362 13.9137 16.4968C14.5664 17.562 15.7777 18.8868 16.4998 18.8868H16.5002C17.2223 18.8868 18.4339 17.562 19.0863 16.4968C21.3226 17.1362 23 19.0762 23 20.8032Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
